const SET_SYSTEM_PRODUCTION = 'SET_SYSTEM_PRODUCTION';
const SET_SYSTEM_PRICE = 'SET_SYSTEM_PRICE';

export {
    SET_SYSTEM_PRODUCTION,
    SET_SYSTEM_PRICE,
};



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/constants.js